import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "relative w-[432px] bg-white rounded-[4px]" }
const _hoisted_2 = { class: "flex pt-[16px] ml-[24px] justify-between items-center" }
const _hoisted_3 = { class: "text-[20px] text-Text/text_high font-gordita-medium" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "uil uil-times !mr-0" }, null, -1)
const _hoisted_5 = { class: "px-[24px]" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-[12px] mb-[16px] text-Text/text_low text-[12px]" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-System/app_white gordita-500-13" }, "Login with Azure AD", -1)
const _hoisted_11 = {
  key: 1,
  class: "mt-[24px] text-Text/text_low text-[12px]"
}
const _hoisted_12 = { class: "flex mt-[8px] items-center justify-between" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ml-[4px] uil uil-plus text-[24px] cursor-pointer" }),
  /*#__PURE__*/_createElementVNode("div", null, "Add group")
], -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex no-wrap flex-col" }
const _hoisted_17 = { class: "h-[448px] mt-[8px]" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "wide-scroller overflow-x-hidden h-[448px]"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 0,
  class: "footer h-[56px]"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = {
  key: 0,
  class: "infinite-spinner-animation rounded-[50%] border-2 border-solid border-white border-b-transparent mr-[8px] !w-[16px] !h-[16px]"
}

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton, IncrediNote, useIncrediDialog } from 'incredi-ui';
import { inject, onMounted, ref } from 'vue';
import SecurityGroupRow from '@/components/common/dialogs/settingsActiveDirectoryDialog/manageSecurityGroupsDialog/securityGroupRow.vue';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { useI18n } from 'vue-i18n';
import { useNotify } from '@/services/notify/notify';
import { ResponseStatus } from '@/const/globals';
import { useSettings_ExternalAuthsQuery } from '@/graphql/codegen/generated/graphql';
import { useAzure } from '@/views/login/loginComponents/azure/azure.helpers';
import azureLogo from '@/assets/images/settings/azureLogoMaterial.svg';
import { IKActiveDirectoryManageGroups } from '@/components/common/dialogs/settingsActiveDirectoryDialog/activeDirectory.injection.keys';
import { NetworkStatus } from '@apollo/client/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageSecurityGroupsDialog',
  setup(__props) {

const { t } = useI18n();
const dialog = useIncrediDialog();
const { toastMessage } = useNotify();
const manageSecurityGroupsHelpers = inject(IKActiveDirectoryManageGroups);
const GQL_get_Active_DirectoryData = useSettings_ExternalAuthsQuery();
const isSaveInProcess = ref(false);
const { handleAzureLogin } = useAzure();

onMounted(async () => {
  if (manageSecurityGroupsHelpers?.GQL_hasAzureCode.networkStatus.value === NetworkStatus.ready) {
    await manageSecurityGroupsHelpers?.GQL_hasAzureCode.refetch();
  } else await manageSecurityGroupsHelpers?.GQL_hasAzureCode.load();
});

const closeDialog = async () => {
  dialog?.close('manageSecurityGroupsDialog');
  sessionStorage.setItem('authMode', String(false));
};

const saveSecurityGroups = async () => {
  if (manageSecurityGroupsHelpers?.isValidForSave()) {
    isSaveInProcess.value = true;
    const result = await manageSecurityGroupsHelpers.saveSecurityGroups();
    GQL_get_Active_DirectoryData?.refetch();
    let message = t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.successToast');
    if (result?.data?.settings_externalAuth_updateGroupRoles?.status !== ResponseStatus.Ok) {
      message = t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.errorToast');
    }
    isSaveInProcess.value = false;
    toastMessage(message, CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
    await closeDialog();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!

  return (_openBlock(), _createBlock(IbxScopedCss, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.title')), 1),
          _createVNode(_unref(IncrediButton), {
            size: "small",
            design: "ghost-grey",
            class: "mr-[16px] w-[32px]",
            fab: "",
            onClick: closeDialog
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(manageSecurityGroupsHelpers)?.showAzureLogin.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.localSubtitle')), 1),
                _createVNode(_unref(IncrediButton), {
                  size: "tiny",
                  style: {"height":"32px","width":"187px","background":"#0070a0"},
                  design: "ghost-grey",
                  onClick: _withModifiers(_unref(handleAzureLogin), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: _unref(azureLogo),
                        class: "mr-[8px]",
                        alt: ""
                      }, null, 8, _hoisted_9),
                      _hoisted_10
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.subtitle')), 1),
                _createElementVNode("div", _hoisted_12, [
                  (_unref(manageSecurityGroupsHelpers)?.isForbiddenToSeeGroups.value)
                    ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                        key: 0,
                        class: "mt-[4px]",
                        type: "Error"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.forbiddenErrorMessageInGroupsList.a')), 1),
                            _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.forbiddenErrorMessageInGroupsList.b')), 1)
                          ])
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_unref(IncrediButton), {
                        key: 1,
                        design: "secondary-green",
                        size: "small",
                        onClick: _withModifiers(_unref(manageSecurityGroupsHelpers)?.addNewRow, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["onClick"])),
                  (!_unref(manageSecurityGroupsHelpers)?.isForbiddenToSeeGroups.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(manageSecurityGroupsHelpers)?.reloadGroups && _unref(manageSecurityGroupsHelpers)?.reloadGroups(...args)))
                      }, [
                        _createVNode(_component_q_icon, {
                          class: _normalizeClass(["uil uil-sync cursor-pointer text-[24px]", {
                  'pointer-events-none': !_unref(manageSecurityGroupsHelpers)?.isDataReadyToShow.value,
                  'text-Old/System/app_grey_76': !_unref(manageSecurityGroupsHelpers)?.isDataReadyToShow.value,
                  'text-System/app_primary': _unref(manageSecurityGroupsHelpers)?.isDataReadyToShow.value,
                }])
                        }, null, 8, ["class"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                ((_unref(manageSecurityGroupsHelpers)?.groupsErrorCounter.value || 0) > 0 && !_unref(manageSecurityGroupsHelpers)?.isForbiddenToSeeGroups.value)
                  ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                      key: 0,
                      class: "mt-[8px]",
                      type: "Error"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.errorMessageInGroupsList.a') + _unref(manageSecurityGroupsHelpers)?.groupsErrorCounter.value + ' groups.'), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.errorMessageInGroupsList.b')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(manageSecurityGroupsHelpers)?.isManualGroupInsert.value && !_unref(manageSecurityGroupsHelpers)?.isForbiddenToSeeGroups.value)
                  ? (_openBlock(), _createBlock(_unref(IncrediNote), {
                      key: 1,
                      class: "mt-[8px]",
                      style: {"padding-right":"0"},
                      type: "Warning"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.numberOfGroupsIsTooLargeToDisplayWarning.a')), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.numberOfGroupsIsTooLargeToDisplayWarning.b')), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.manageSecurityGroups.numberOfGroupsIsTooLargeToDisplayWarning.c')), 1)
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            (_unref(manageSecurityGroupsHelpers)?.isDataReadyToShow.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(manageSecurityGroupsHelpers)?.currentGroupsMapping.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createVNode(SecurityGroupRow, {
                        group: item.group || '',
                        "manual-insert": _unref(manageSecurityGroupsHelpers)?.isManualGroupInsert.value,
                        "is-single-admin": index === 0,
                        options: _unref(manageSecurityGroupsHelpers)?.existingGroups.value as any,
                        disabled: _unref(manageSecurityGroupsHelpers)?.isEditingManageGroupsDisabled.value,
                        role: item.role,
                        "error-message": item.errorMessage,
                        onOnGroupSelection: ($event: any) => (_unref(manageSecurityGroupsHelpers)?.updateGroupSelection(index, $event)),
                        onOnRoleSelection: ($event: any) => (_unref(manageSecurityGroupsHelpers)?.updateRoleSelection(index, $event)),
                        onDeleteRow: ($event: any) => (_unref(manageSecurityGroupsHelpers)?.deleteSecurityGroup(index))
                      }, null, 8, ["group", "manual-insert", "is-single-admin", "options", "disabled", "role", "error-message", "onOnGroupSelection", "onOnRoleSelection", "onDeleteRow"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_q_linear_progress, {
                    indeterminate: "",
                    color: "bg-System/app_primary",
                    class: "q-mt-sm"
                  })
                ]))
          ])
        ]),
        (!_unref(manageSecurityGroupsHelpers)?.isEditingManageGroupsDisabled.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_unref(IncrediButton), {
                design: "primary-green",
                size: "small",
                class: "flex mr-[12px] mt-[6px] justify-end",
                disabled: isSaveInProcess.value,
                onClick: _withModifiers(saveSecurityGroups, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    (isSaveInProcess.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", null, _toDisplayString(isSaveInProcess.value ? 'Saving' : 'Save'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})